import { __assign, __awaiter, __generator } from "tslib";
import { getFontForFontPicker, getAppFontFromFontPicker, } from './BaseFontAndColorPicker';
export function openFontPicker(SDKAdapter, _a) {
    var font = _a.font, fontPickerTitle = _a.fontPickerTitle, fontPickerOptions = _a.fontPickerOptions, onFontChange = _a.onFontChange, position = _a.position;
    return __awaiter(this, void 0, void 0, function () {
        var HORIZONTAL_OFFSET, VERTICAL_OFFSET, presets, fontPickerConfig;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    HORIZONTAL_OFFSET = 6;
                    VERTICAL_OFFSET = fontPickerOptions.showHTMLTag ? -300 : 0;
                    return [4 /*yield*/, SDKAdapter.getSiteTextPresets()];
                case 1:
                    presets = _b.sent();
                    fontPickerConfig = __assign(__assign({}, fontPickerOptions), { left: position.right + HORIZONTAL_OFFSET, top: position.top + VERTICAL_OFFSET, value: getFontForFontPicker(presets, font), title: fontPickerTitle });
                    SDKAdapter.openFontPicker(fontPickerConfig, function (values) {
                        if (values.fontParam) {
                            onFontChange(getAppFontFromFontPicker(values.fontParam));
                        }
                    });
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=openFontPicker.js.map